




















import Vue from "vue";
import userManager from "@/services/userManager";
import PasswordProtected from "@/components/PasswordProtected.vue";

export default Vue.extend({
  components: {
    PasswordProtected,
  },
  data() {
    return {
      self: this,
      item: null,
      currentTab: "",
      tabs: {
        partners: {
          label: "Quản lý đối tác",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
        receive_accounts: {
          label: "Tài khoản nhận tiền",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
        vnd_transactions: {
          label: "Đổi tác trả tiền theo thời điểm thực nhận",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
        transactions: {
          label: "Đổi tác trả tiền theo mã giao dịch",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
        shop_wallet_transactions: {
          label: "Giao dịch trên sàn",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
        statistics: {
          label: "Tổng thống kê",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
      },
    };
  },
});
